import api from 'Application/api/api';

const createCampaign = async (signal, values) => {
	const response = await api.post('/finances', values, {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
	};
};

export default createCampaign;
